<script lang="ts">
  import type { DiagnosticResult } from '$core/diagnostic.types';
  import { selectExecutiveHighlights } from '$core/report/executiveHighlights';
  import ExecutiveSummary from './ExecutiveSummary.svelte';
  import ImportSummary from './ImportSummary.svelte';
  import MaturityScoreCard from './MaturityScoreCard.svelte';
  import MetricsSections from './MetricsSections.svelte';
  import AnalyticsPanel from './AnalyticsPanel.svelte';
  import RecommendationsPanel from './RecommendationsPanel.svelte';
  import { appStore } from '../../app/store';

  export let result: DiagnosticResult;

  const appState = appStore.state;
  $: highlights = selectExecutiveHighlights(result);
  $: assumptions = $appState.assumptions;
</script>

<div class="dashboard-page">
  <ImportSummary dataset={result.dataset} />

  <section class="dashboard-page__section">
    <h2 class="dashboard-page__section-title">Resumo Executivo</h2>
    <ExecutiveSummary {highlights} />
  </section>

  <section class="dashboard-page__section">
    <h2 class="dashboard-page__section-title">Score de Maturidade</h2>
    <MaturityScoreCard score={result.score} />
  </section>

  <section class="dashboard-page__section">
    <h2 class="dashboard-page__section-title">Análise Visual</h2>
    <AnalyticsPanel {result} {assumptions} />
  </section>

  <section class="dashboard-page__section">
    <h2 class="dashboard-page__section-title">Métricas Detalhadas</h2>
    <MetricsSections metrics={result.metrics} dataset={result.dataset} {assumptions} />
  </section>

  <section class="dashboard-page__section">
    <h2 class="dashboard-page__section-title">Recomendações</h2>
    <RecommendationsPanel recommendations={result.recommendations} />
  </section>
</div>

<style>
  .dashboard-page {
    display: flex;
    flex-direction: column;
    gap: var(--ptt-space-8);
    max-width: 1200px;
    margin: 0 auto;
    padding: var(--ptt-space-6) var(--ptt-space-5);
  }

  .dashboard-page__section {
    display: flex;
    flex-direction: column;
    gap: var(--ptt-space-4);
  }

  .dashboard-page__section-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--ptt-gray-300);
    margin: 0;
    padding-bottom: var(--ptt-space-2);
    border-bottom: 2px solid var(--ptt-gray-20);
  }

  @media (max-width: 768px) {
    .dashboard-page {
      padding: var(--ptt-space-4) var(--ptt-space-3);
      gap: var(--ptt-space-6);
    }
  }

  @media (max-width: 480px) {
    .dashboard-page {
      padding: var(--ptt-space-3) var(--ptt-space-2);
    }
  }
</style>
